/**
 * Home page · P1.8 + P2.8.A4
 *
 * Reads the logged-in workspace_id from sessionStorage (set by /login) and
 * links to it. Prior version hardcoded `demo` workspace · which after dev
 * login (which sets actual UUID workspace) caused canvas page to refuse
 * with "Wrong workspace" mismatch. (codex P2.8.A4 R1 P1 fix)
 */

import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function readWorkspaceId(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem('aiw.spa.workspace_id');
}

export function homeStatusText(workspaceId: string | null): string {
  return workspaceId
    ? `已登录 workspace ${workspaceId}`
    : '未登录 · 请先登录';
}

export function homePrimaryAction(workspaceId: string | null): { label: string; kind: 'login' | 'workspace'; workspaceId?: string } {
  return workspaceId
    ? { label: '进入工作区', kind: 'workspace', workspaceId }
    : { label: '登录', kind: 'login' };
}

function HomePage() {
  const [workspaceId, setWorkspaceId] = useState<string | null>(() => readWorkspaceId());
  const action = homePrimaryAction(workspaceId);

  useEffect(() => {
    setWorkspaceId(readWorkspaceId());
  }, []);

  return (
    <div>
      <h1>aiw · home</h1>
      <p style={{ color: 'var(--fg-soft)' }}>
        {homeStatusText(workspaceId)}
      </p>
      {action.kind === 'workspace' && action.workspaceId ? (
        <Link
          to="/workspace/$workspaceId"
          params={{ workspaceId: action.workspaceId }}
          data-testid="home-primary-workspace"
        >
          {action.label}
        </Link>
      ) : (
        <Link to="/login" data-testid="home-primary-login">{action.label}</Link>
      )}
    </div>
  );
}
